export default {
  pageName: 'Guidelines - Monitor Method',
  pageId: '25034',
  pagePath: '/opinion/MonitorScope',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
};
